
import Vue from "vue";
import { mapMutations } from "vuex";
import VButton from "@/components/common/button.vue";

export default Vue.extend({
  name: "component-top-view-menu-header",
  props: {
    isTopView: { type: Boolean, default: false },
    isScrolling: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false },
  },
  components: { VButton },
  computed: {
    showLogoImg(): string {
      return this.isScrolling
        ? require("@/assets/images/logo_vacan_gray.svg")
        : require("@/assets/images/logo_vacan_w.svg");
    },
  },
  methods: {
    ...mapMutations("ui", ["showMenuPanel"]),
    menuClicked() {
      this.$emit("open-menu");
    },
  },
});
